<template>
  <!-- Real company internship item -->
  <div class="assignments-item" v-if="type == 'company'" :class="{ not_expanded: !item.expanded }">
    <div class="assingment-left-side">
      <div class="assignments-item-brand">
        <img v-if="$hasKey(item, 'owner.customer_profile.logo')"
          :src="$fullUrl('images/profiles/' + item.owner.customer_profile.logo)" />
        <img v-else src="@/assets/icons/logo_avatar.svg" />
      </div>
    </div>
    <div class="assingment-right-side">
      <div class="assignments-item-header">
        <div class="content">
          <!-- For company -->
          <div class="internship-details" v-if="item.published">
            <h1 class="internship-title">{{ item.name }}</h1>

            <div class="internship-row-info" v-if="$hasKey(item, 'owner.customer_profile.name')">
              <label class="company-name">{{
                item.owner.customer_profile.name
              }}</label>
            </div>
            <div class="internship-row-info" v-if="item.expanded && $hasKey(item, 'owner.customer_profile.address')
                ">
              <img src="@/assets/icons/internship/location.svg" class="icon" />
              <span class="company-location">
                {{ item.owner.customer_profile.address }}</span>
            </div>
          </div>
          <!-- For internal internship f -->
          <div v-else class="internship-details">
            <h1 class="internship-title">{{ item.name }}</h1>

            <div>
              <div class="internship-row-info" v-if="item.location">
                <img src="@/assets/icons/internship/location.svg" class="icon" />

                <span v-for="(location, index) in item.location" :key="index" class="company-location">{{ location
                }}</span>
              </div>
              <div class="internship-row-info" v-if="item.account &&
                item.account != '{}' &&
                item.expanded &&
                item.account.worktype
                ">
                <img src="@/assets/icons/internship/workplace.svg" class="icon" />
                <span class="company-worktype">{{
                  item.account.worktype
                }}</span>
              </div>
              <div class="internship-row-info" v-if="item.account &&
                  item.account != '{}' &&
                  item.expanded &&
                  item.account.website
                  ">
                <img src="@/assets/icons/internship/website.svg" class="icon" />
                <span class="company-website"><a :href="item.account.website" target="_blank">{{
                  item.account.website
                }}</a></span>
              </div>
            </div>
          </div>
        </div>

        <button class="toogle-panel-btn" @click="item.expanded = !item.expanded">
          <img v-if="item.expanded" src="@/assets/admin-icon/allow-blue-up.svg" />
          <img v-else src="@/assets/admin-icon/allow-blue-down.svg" />
        </button>

        <!-- Not expanded date -->
        <div v-if="!item.expanded" class="not_expanded-time">
          <span>{{ item.created_at | formatDate }}</span>
        </div>
      </div>
      <div class="assignments-item-body" v-if="item.expanded">
        <div class="assignments-info" v-if="item.description">
          <label class="label">Description</label>
          <p class="assignment-desc">
            {{ item.description }}
          </p>
        </div>
        <div class="tags-time" :class="{ no_tag: item.tags == 0 }">
          <div class="tags-widget">
            <div class="tag-item" v-for="(tag, g) in item.tags" :key="g">
              {{ tag.name }}
            </div>
          </div>
          <div class="time">
            <span>{{ item.created_at | formatDate }}</span>
          </div>
        </div>
      </div>

      <!-- Contact -->

      <div class="account-profile" v-if="item.expanded &&
        !item.published &&
        item.account &&
        item.account.contact_type == 'company_contact'
        ">
        <div class="account-details">
          <h3 class="account-contact-name">Student Contact</h3>
          <p class="account-contact-email" :title="item.account.email">
            <a target="_blank" v-if="validateEmail(item.account.email)" :href="`mailto: ${item.account.email}`">
              {{ item.account.email }}</a>
            <a target="_blank" v-if="validateEmail(item.account.phone)">
              {{ item.account.phone }}</a>
            <a target="_blank" v-if="item.account.website" :href="`${item.account.website}`">
              {{ item.account.website }}</a>
          </p>
        </div>
      </div>

      <div class="item-option" v-if="item.expanded">
        <!-- Number -->
        <div class="assignment-people">
          <label v-if="item.students">{{ item.students.length }} Candidates interested to this LIA
          </label>
        </div>
        <!-- Company option internship -->
        <div class="assignment-options" v-if="item.published">
          <app-dialog v-if="(item.published &&
            $cookies.get('account-type') == 1 &&
            !item.applied) ||
            (item.published &&
              $cookies.get('account-type') == 4 &&
              !item.applied)
            " title="Please Confirm"
            ask="Are sure? By applying the LIA, you give permission to this company to view full profile" yesText="Yes"
            noText="No" yesBtnClass="approve-widget" @onComfirm="applyInternship(item)">
            <button class="btn-apply">Apply</button>
          </app-dialog>

          <div v-if="(item.published &&
            $cookies.get('account-type') == 1 &&
            item.applied) ||
            (item.published &&
              $cookies.get('account-type') == 4 &&
              item.applied)
            " class="applied-badget">
            <img src="@/assets/icons/white-confirm.svg" />
            Applied
          </div>
        </div>

        <!-- School option internship -->
        <div class="assignment-options"></div>
      </div>
    </div>
  </div>
  <!-- Lia internship item-->
  <div v-else-if="type == 'school'" class="internship-item">
    <div class="internship-item-header">
      <div class="internship-item-header-left">
        <h1 class="internship-item-title">{{ item.name | validate }}</h1>
        <p class="internship-location">{{ location | validate }}</p>
      </div>
      <div class="internship-item-header-right">
        <div class="internship-item-date">
          <span v-if="item.from">{{ item.from | formatDate }}</span>
        </div>
        <div class="internship-item-worktype">
          <span>{{ item.account.worktype | validate }}</span>
        </div>
      </div>
    </div>
    <div class="internship-item-body">
      <div class="internship-item-description">
        {{ item.description | validate }}
      </div>
      <div class="internship-item-tags">
        <template v-for="(tag, index) in item.tags">
          <widgetTagItem :key="index" :value="tag.name" :canClose="false"></widgetTagItem>
        </template>
      </div>
      <div v-if="false && item.account && item.account.public_contact" class="internship-contact-header">
        Student’s contact
      </div>
      <div class="intership-contact" v-if="item.account && item.account.public_contact">
        <div class="internship-contact-avatar">
          <img src="@/assets/icons/lia_contact_avatar.svg" />
        </div>
        <div class="internship-contact-info">
          <div class="internship-contact-name">
            {{ item.account.first_name | validate }}
            {{ item.account.last_name | validate }}
          </div>
          <div class="internship-contact-email">
            {{ item.account.public_contact | validate }}
          </div>
          <div v-if="false" class="internship-contact-phone">
            {{ item.account.phone_alt | validate }}
          </div>
        </div>
      </div>
      <div class="internship-footer-contact-website">
        <a :href="'https://' + website" target="_blank">{{
          website | validate
        }}</a>
      </div>
      <div class="internship-candidates">
        <div class="internship-interested-candidates" v-if="item.selected_or_interested &&
            item.selected_or_interested.length > 0
            ">
          <template v-for="(student, index) in item.selected_or_interested">
            <widgetProfile v-if="index < 3" :title="student.first_name + ' ' + student.last_name" :key="index"
              :class="index > 0 ? 'move-left' : ''" :size="20" :text_size="8" :file_name="student.profile_picture"
              :path="$fullUrl('images/profiles/')" :showContent="false" :enableRightMargin="false"></widgetProfile>
          </template>
          <div v-if="item.selected_or_interested.length > 3" class="internship-interested-candidates-count">
            and {{ item.selected_or_interested.length - 3 }} more are interested
          </div>
        </div>
        <div v-else class="internship-interested-candidates">
          <div class="internship-interested-candidates-count">
            No candidates are interested
          </div>
        </div>
      </div>
    </div>
    <div class="internship-footer">
      <div class="internship-footer-left">
        <button class="btn-copy" v-clipboard:copy="shareInternship(item)" v-clipboard:success="clipboardSuccessHandler"
          v-clipboard:error="clipboardErrorHandler">
          <img src="@/assets/icons/copy.svg" />
          Share
        </button>
      </div>
      <div class="internship-footer-right">
        <app-dialog v-if="(!item.applied &&
          !$getLoggedUser().matched &&
          $cookies.get('account-type') == 1 &&
          !item.applied) ||
          (!item.applied && $cookies.get('account-type') == 4)
          " title="LIA interest" :ask="`Show interest in this ${item.name} ?`" yesText="Confirm" noText="Cancel"
          yesBtnClass="approve-widget" @onComfirm="selectInternship(item)">
          <widgetButton class="btn-primary" :loading="item.loading">
            I am interested
          </widgetButton>
        </app-dialog>
        <div v-if="($cookies.get('account-type') == 1 && item.applied) ||
          ($cookies.get('account-type') == 4 && item.applied)
          " class="interested-badget">
          <img src="@/assets/icons/confirm.svg" />
          Interested
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "internship-item",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    location() {
      let vm = this;
      let full_location = "";
      if (!vm.item.published && Array.isArray(vm.item.location)) {
        vm.item.location.forEach((location, index) => {
          full_location += index == 0 ? location : ", " + location;
        });
      }
      return full_location;
    },
    website() {
      let vm = this;
      let website = vm.item.account.website;
      if (website) {
        website = website.replace("https://", "");
        website = website.replace("http://", "");
      }
      return website;
    },
  },
  watch: {},
  methods: {
    clipboardSuccessHandler({ value, event }) {
      let vm = this;
      vm.$notify({
        group: "status",
        title: "Message",
        text: "Link copied",
        type: "success",
        duration: 3000,
      });
    },

    clipboardErrorHandler({ value, event }) {
      let vm = this;
      vm.$notify({
        group: "status",
        title: "Something wrong",
        text: "Error while copying, Please try again.",
        type: "warn",
        duration: 3000,
      });
    },
    shareInternship(item) {
      let host = window.location.hostname;
      let protocol = window.location.protocol;
      return protocol + "//" + host + "/lia?internship=" + item.id;
    },
    applyInternship(item) {
      let vm = this;
      vm.$emit("apply", item);
    },
    selectInternship(item) {
      let vm = this;
      vm.$emit("select", item);
    },
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
  },
};
</script>
<style lang="scss" scoped>
.assignments-item {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
  display: flex;
  padding: 20px;

  @media (min-width: 300px) and (max-width: 630px) {
    padding: 14px 16px;
    margin: 13px 7px;
  }

  &.active {
    background: #1885ad15;
  }

  .assingment-left-side {
    width: 60px;
    margin-right: 10px;

    .assignments-item-brand {
      display: flex;
      align-items: center;
      width: 100%;

      img {
        width: 49px;
        height: 49px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }

  .assingment-right-side {
    width: calc(100% - 70px);
    position: relative;

    .assignments-item-header {
      display: flex;
      padding-bottom: 10px;

      .content {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: flex-start;

        .internship-details {
          width: 100%;
          display: flex;
          flex-direction: column;

          .internship-title {
            width: calc(100% - 40px);
            font-size: 19px;
            font-weight: 500;
            margin-top: 11px;
            transition: 500ms ease-in-out;
          }

          .internship-row-info {
            display: flex;
            align-items: center;
            margin-bottom: 2px;

            .icon {
              margin-right: 5px;
              width: 15px;
            }

            .company-name {
              font-size: 14px;
            }

            .company-location {
              font-size: 13px;
              color: #1ba5a4;
              position: relative;
              top: 3px;
            }

            .company-worktype {
              color: #1ba5a4;
              font-size: 13px;
              position: relative;
              top: 3px;
            }

            .company-website {
              font-size: 13px;
              position: relative;
              top: 3px;

              a {
                word-break: break-all;
                color: #0884af;
              }
            }
          }
        }
      }

      .toogle-panel-btn {
        padding: 1px 7px;
        font-size: 16px;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        color: #ccc;
        position: absolute;
        top: 0px;
        right: 0px;
        height: 15px;
      }

      .not_expanded-time {
        color: #707070;
        position: absolute;
        top: 32px;
        right: 0px;
        font-size: 12px;
      }
    }

    .assignments-item-body {
      .assignments-info {
        .label {
          margin-bottom: 5px;
          display: block;
        }

        p.assignment-desc {
          color: #707070;
          margin: 0px;
          margin-bottom: 11px;
          text-align: justify;
        }
      }

      .tags-time {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid rgb(247, 247, 247);
        padding-top: 8px;
        padding-bottom: 8px;

        &.no_tag {
          padding-top: 0px;
          border-top: none;
        }

        .tags-widget {
          display: flex;
          flex-wrap: wrap;
          width: 60%;

          .tag-item {
            background: #ebebeb;
            border-radius: 20px;
            padding: 2px 10px;
            margin-right: 10px;
            font-size: 10px;
            margin-bottom: 10px;
            font-weight: 800;
            color: #000;
          }
        }

        .time {
          span {
            color: #707070;
            font-size: 13px;
          }
        }
      }
    }

    .account-profile {
      display: flex;
      padding-top: 5px;
      padding-right: 10px;
      border-top: 1px solid rgb(247, 247, 247);

      .account-details {
        width: 100%;

        .account-contact-name {
          font-size: 14px;
          margin: 0px;
        }

        .account-contact-email {
          font-size: 12px;
          margin: 0px;
          position: relative;
          top: -2px;
          overflow: hidden;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;

          a {
            color: #0884af;
          }
        }
      }
    }

    .item-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 10px;
      border-top: 1px solid rgb(247, 247, 247);

      .assignment-people {
        display: flex;
        flex-direction: column;

        label {
          font-size: 12px;

          .btn-dropdown {
            width: 10px;
            cursor: pointer;
          }
        }

        .people-profiles {
          display: flex;
          flex-direction: column;
          position: relative;
          left: -4px;
          margin-top: 5px;

          .people-item {
            display: flex;
            align-items: center;

            .profile-image {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              border: 2px solid #fff;
              object-fit: cover;

              &.override {
                margin-left: -6px;
              }
            }

            span {
              font-size: 11px;
            }
          }
        }
      }

      .assignment-options {
        .applied-badget {
          background: #1ba5a4;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          padding: 5px 13px;
          color: #fff;
          display: flex;
          align-items: center;
          position: relative;
          right: -19px;

          img {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }

        .interested-badget {
          background: #888888;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          padding: 5px 13px;
          color: #fff;
          display: flex;
          align-items: center;
          position: relative;
          right: -19px;

          img {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }

        .btn-apply {
          background: #0884af;
          border-radius: 5px;
          padding: 5px 28px;
          color: #fff;
        }

        .btn-select {
          background: #1ba5a4;
          border-radius: 5px;
          padding: 5px 11px;
          color: #fff;
        }
      }
    }
  }

  &.not_expanded {
    align-items: center;

    .assignments-item-header {
      padding-bottom: 0px;

      .internship-title {
        font-size: 19px;
        font-weight: 500;
        margin-top: 0px !important;
        transition: 500ms ease-in-out;
        overflow: hidden;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.internship-item {
  display: flex;
  flex-direction: column;
  width: 440px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;

  @media (min-width: 300px) and (max-width: 630px) {
    width: 100%;
  }



  .internship-item-header {
    width: 100%;
    padding: 8px 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .internship-item-header-left {
      display: flex;
      flex-direction: column;
      width: calc(100% - 120px);

      .internship-item-title {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        color: #18181b;
        margin: 0px;
        overflow: hidden;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .internship-location {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        color: #a1a1aa;
        margin: 0px;
        overflow: hidden;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .internship-item-header-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: 100px;

      .internship-item-date {
        font-size: 12px;
        color: #707070;
        margin-right: 10px;
      }

      .internship-item-worktype {
        font-size: 12px;
        color: #0884af;
        background: #f0fdfa;
        border-radius: 20px;
        padding: 5px 10px;
        text-transform: capitalize;
        text-align: center;
      }
    }
  }

  .internship-item-body {
    .internship-item-description {
      padding: 8px 11px;
    }

    .internship-item-tags {
      display: flex;
      flex-wrap: wrap;
      padding: 8px 11px;
    }

    .internship-contact-header {
      padding: 5px 8px;
      border-bottom: 1px solid #d8d8d8;
      width: 60%;
      color: #707070;
      font-style: italic;
    }

    .intership-contact {
      display: flex;
      align-items: center;
      padding: 8px 11px;

      .internship-contact-avatar {
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 10px;
        }
      }

      .internship-contact-info {
        .internship-contact-email {
          font-size: 13px;
          margin: 0px;
          color: #0884af;
          overflow: hidden;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .internship-contact-phone {
          font-size: 13px;
          margin: 0px;
          overflow: hidden;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .internship-footer-contact-website {
      padding: 8px 11px;

      a {
        color: #0884af;
        text-decoration: none;
      }
    }

    .internship-candidates {
      display: flex;
      padding-left: 5px;
      padding: 8px 11px;
      padding-bottom: 10px;

      .internship-interested-candidates {
        display: flex;
        align-items: center;

        .move-left {
          position: relative;
          left: -5px;

          .profile-image {
            border: 2px solid #fff;
          }
        }

        .internship-interested-candidates-count {
          font-size: 12px;
          color: #707070;
          margin-right: 10px;
          position: relative;
          left: 5px;
        }
      }
    }
  }

  .internship-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fbfbfb;
    margin-top: 10px;
    padding: 8px 11px;
    height: 53px;

    .internship-footer-left {
      display: flex;

      .btn-copy {
        padding: 5px 0px;
        display: flex;
        align-items: center;
        color: #1ba5a4;

        img {
          margin-right: 6px;
          width: 20px;
        }
      }
    }

    .internship-footer-right {
      .interested-badget {
        color: #1ba5a4;
        padding: 0px 13px;
        height: 45px;
        display: flex;
        align-items: center;
        border: 1px solid #1ba5a4;
        border-radius: 10px;

        img {
          width: 15px;
          height: 15px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
